import { ProductsService } from './products';

export async function findAllManufacturersOfVoice (): Promise<any> {
    return ProductsService.findAllManufacturersOfVoice();
}



// WEBPACK FOOTER //
// ./app/bundles/enterprise-shop/src/api/services/products/products.find-all-manufacturers-of-voice.ts